import { render } from "./career.vue?vue&type=template&id=65265551&ts=true"
import script from "./career.vue?vue&type=script&lang=ts"
export * from "./career.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__